import CRMTripManagement from "../Trips";

export default function CRMUniversalOrlando() {
  return <CRMTripManagement destination="universal_orlando" />;
}
